import axios from 'axios'

const TASK_LIST_PATH = '/api/app/core/video/task/list'

/**
 * 分页查询当前用户分析任务
 * @param {{ pageNum?: number, pageSize?: number, status?: string }} [params]
 * @returns {Promise<{ records: Array, total: number, pageNum: number, pageSize: number }>}
 */
export async function fetchAnalysisTaskList(params = {}) {
  const pageNum = params.pageNum != null ? params.pageNum : 1
  const pageSize = params.pageSize != null ? params.pageSize : 20
  const query = { pageNum, pageSize }
  if (params.status != null && String(params.status).trim() !== '') {
    query.status = String(params.status).trim()
  }
  const { data } = await axios.get(TASK_LIST_PATH, { params: query })
  return data && typeof data === 'object' ? data : { records: [], total: 0, pageNum, pageSize }
}

export const TASK_STATUS_LABELS = {
  PENDING: '排队中',
  QUEUED: '排队中',
  PROCESSING: '分析中',
  SUMMARIZING: '内容总结中',
  COMPLETED: '已完成',
  FAILED: '失败'
}

export function getTaskStatusLabel(status) {
  const key = status != null ? String(status).trim().toUpperCase() : ''
  return TASK_STATUS_LABELS[key] || (key || '未知')
}

export function getTaskStatusTone(status) {
  const key = status != null ? String(status).trim().toUpperCase() : ''
  if (key === 'COMPLETED') return 'success'
  if (key === 'FAILED') return 'danger'
  if (key === 'PROCESSING' || key === 'PENDING' || key === 'QUEUED' || key === 'SUMMARIZING') return 'warning'
  return 'info'
}
